import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  from: '',
  enableMms: false,
  mediaUrls: '',
  statusCallback: '',
  validityPeriod: 14400,
};

export default defaults;
